<template>
  <div>
    <div class='img-content  uk-position-relative border uk-flex'>
      <img :src='carrierImg' alt='' draggable='false' v-if='carrierImg' />
      <div v-else>
        <el-empty :description="$t('integration.no_pictures_of_monitoring_points')" style='height:400px'></el-empty>
      </div>
      <span class='uk-position-absolute select-no cursor-pointer uk-text-nowrap' style='color: #344962' :style="{
                left: item.xpos * rate + 'px',
                top: item.ypos * rate + 'px'
            }" v-if='carrierImg' v-for='(item, index) in equiPoint' :key='index'
              @click="clickPoint(item)">
                <template v-if='item.xpos && item.ypos'>

                    <!-- 传感器 -->
                    <el-tooltip v-if="item.deviceCatalog === '0'" class='item' effect='dark' placement='right'>
                        <div slot='content'>
                            {{ $t('public.is_abnormal') }}:{{ item.ex.join(',') || $t('public.normal') }}

                            <template v-if='item.ranges !== undefined && item.ranges.length'>
                                <span v-for='range in item.ranges'>
                                    <br />
                                    {{ range.code === 'temp' ? $t('device.temp_range') : $t('device.hum_range') }}:
                                    {{ range.name }} {{ range.min }}{{ range.unitName }}~{{
                                    range.max }}{{ range.unitName }}
                                </span>
                            </template>

                          <!-- <span v-if="item.min_hum !== undefined">
                              <br />
                              {{ $t('device.hum_range') }}:
                              {{ item.humidityRange.name }} {{ item.humidityRange.min }}{{ item.humidityRange.unitName
                              }}~{{ item.humidityRange.max }}{{ item.humidityRange.unitName }}
                          </span> -->
                            <br />
                            <span v-if='item.probeValue && item.probeValue.temp' class='uk-margin-small-right'>
                                {{ $t('device.temp_val') }}:
                                <span v-range="[item.probeValue['temp'].val, item.tempRange]">
                                    {{ item.probeValue.temp.val }}{{ defaultUnit['temp'] }}
                                </span>
                            </span>

                            <span v-if='item.probeValue && item.probeValue.hum'>{{ $t('device.hum_val') }}:<span
                              v-range="[item.probeValue['hum'].val, item.humidityRange]">{{ item.probeValue.hum.val
                              }}{{ defaultUnit['hum'] }}</span></span>
                        </div>
                        <span class='uk-text-bold'>{{ item.deviceCode }}
                            <template v-if='item.probeValue && item.probeValue.temp'><span
                              v-range="[item.probeValue['temp'].val, item.tempRange]" class='uk-text-bold'>{{
                                item.probeValue.temp.val }}{{ defaultUnit['temp'] }}</span></template>

                            <template v-if='item.probeValue && item.probeValue.hum'><span>/</span>
                                <span class='uk-text-bold' v-range="[item.probeValue['hum'].val, item.humidityRange]">{{
                                    item.probeValue.hum.val }}{{ defaultUnit['hum'] }}</span>
                            </template>
                        </span>
                    </el-tooltip>

                  <!-- 其他 -->
                    <el-tooltip v-else class='item' effect='dark' placement='right'>
                        <div slot='content'>{{ $t('public.is_abnormal') }}:{{ item.status ? $t('public.ex_conn') :
                          $t('public.normal') }}</div>
                        <span class='uk-text-bold'>{{ item.name }}</span>
                    </el-tooltip>
                </template>
            </span>
      <!-- 右边选中的设备信息 -->
      <div style="border-left: 1px solid #CCCCCC;" class="pd-10">
        <div v-if="deviceObj">
          <div class="uk-flex mb-10" style="justify-content: end;">
            <i
                class="iconfont icon-zhexiantu cursor-pointer font-16"
                :title="$t('integration.monitoring_point_chart')"
                @click="toDeviceHistory"
              ></i>
            <i class="el-icon-refresh font-16 ml-10"></i>

          </div>
          <p class="mb-10">
              <i v-if="!deviceObj.abnormal" class="el-icon-circle-check color-green"></i>
              <i v-else class="el-icon-warning-outline color-red"></i>
              {{deviceObj.carrier_device_name}}
          </p>
          <p class="mb-10">
              <i class="el-icon-price-tag"></i>
              {{deviceObj.deviceCode}}
          </p>
          <p v-if="deviceObj.probeValue.temp" class="mb-10">
              <i class="el-icon-time"></i>
              {{$timetransition(deviceObj.probeValue.temp.time)}}
          </p>
          <p v-else-if="deviceObj.probeValue.hum" class="mb-10 ">
              <i class="el-icon-time"></i>
              {{$timetransition(deviceObj.probeValue.hum.time)}}
          </p>
          <div class="uk-flex mb-10 pd-10 ">
              <div v-if="deviceObj.probeValue.temp">
                  <p class="mb-10 font-16" style="color: #000;text-align: center;">{{deviceObj.probeValue.temp.val}}℃</p>
                  <p v-if="deviceObj.tempRange">{{deviceObj.tempRange.min}}℃ ~ {{deviceObj.tempRange.max}}℃</p>
              </div>
              <div v-if="deviceObj.probeValue.hum" style="margin-left:30px;">
                  <p class="mb-10 font-16" style="color: #000;text-align: center;">{{deviceObj.probeValue.hum.val}}%RH</p>
                  <p v-if="deviceObj.humRange">{{deviceObj.humRange.min}}%RH ~ {{deviceObj.humRange.max}}%RH</p>
              </div>
          </div>
          <p v-if="deviceObj.description">
              <i class="el-icon-document"></i>
              {{$timetransition(deviceObj.description)}}
          </p>
        </div>
        <div v-else style="margin-top:200px;">
          <span style="text-align: center;">{{ $t('integration.please_select_device')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { sensorEx } from '@/utils/exception'
import { defaultUnit } from '@/utils/convert'
import { sensorHistoryQueryFormat } from '@/utils/simplify/query'
import { sensorHistory } from '@/utils/winDetail'
export default {
  computed: {
    defaultUnit () {
      return defaultUnit
    }
  },
  props: ['detailObj'],
  data () {
    return {
      // 图片的缩放比
      rate: 0,
      carrierImg: '',
      // 根据挂载生成锚点列表
      equiPoint: [],
      deviceObj: null
    }
  },
  watch: {
    detailObj (newval) {
      // 详细信息改变意味着图片可能会发生改变
      this.carrierImg = (newval.carrierExtend && newval.carrierExtend.pictureBase64) || (newval.carrierType && newval.carrierType.pictureBase64)
      this.handleImg(this.carrierImg)
      // 标记异常
      this.equiPoint = sensorEx(this.detailObj.carrierDevice.deviceList)
      console.log(this.equiPoint)
      // 标记设备类型
    },
    carrierImg () {
      this.handleImg(this.carrierImg)
    }
  },
  methods: {
    // 用于处理图片缩放比的计算 与锚点
    handleImg (picture) {
      // 获取图片的宽度  进而得到图片被压缩成400px后的缩放比  以后每次锚点计算 都要乘上这个缩放比
      const img = new Image()

      img.src = picture

      // 避免图片没回来时硬刷新坐标错位问题
      img.onload = () => {
        // 获取图片的缩放比 每次计算锚点都需要乘上这个比例
        if (img.width > img.height) {
          this.rate = 400 / img.width
        } else {
          this.rate = 400 / img.height
        }
      }
    },
    // 点击了某个设备，右边设备信息显示该设备
    clickPoint(item){
      console.log('clickPoint------', item )
      this.deviceObj = item
    },
    toDeviceHistory(){
      let row = this.deviceObj
      const params = sensorHistoryQueryFormat(row)
      // 因为传感器写的历史数据的组件接口请求参数的值no:tag_id,气体么有tag_id，使用gas_code
      params.tagId = row.deviceCode
      // 因为传感器写的历史数据的组件接口请求参数的值devCatalog直接写的0,气体要格外增加一些参数修改
      // params.devCatalog = 5
      if(parseInt(row.deviceCatalog) == 5){
          if(row.deviceType ===6){
              params.probe = 'coz'
          }else{
              params.probe = 'gas'
          }
      }
      params.probeValue = params.probeValue.temp ? 'temp' : (params.probeValue.hum ? 'hum' : '')
      // 有些字段命名不一样
      params.scopeName =  row.sceneName
      params.carrierName =  row.carrierName
      params.carrierId =  row.carrierId
      params.carrierTypeId =  row.carrierType
      sensorHistory(params)
    }
  },
  mounted () {
  }
}
</script>

<style scoped lang='scss'>
.img-content {
  width: 550px;
  height: 500px;
  overflow: hidden;

  img {
    width: 70%;
    max-height: 500px;
    object-fit: contain;
    object-position: left top;
  }
}
</style>
